import MenuSection from "../MenuSection";
import React from "react";
import RegisterOrDepositMenuItem from "./RegisterOrDepositMenuItem";
import PropTypes from "prop-types";

const TopMenuSection = ({ trackingInfo }) => (
  <MenuSection>
    <RegisterOrDepositMenuItem trackingInfo={trackingInfo} />
  </MenuSection>
);

TopMenuSection.propTypes = {
  trackingInfo: PropTypes.object
};

export default React.memo(TopMenuSection);
